const shopifyUrl = 'https://empleados.diageochile.com';
const accessToken = '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';
// let customerId = customerId;
const apiVersion = '2024-07';

let checkoutButton = document.querySelector('.cart__checkout-button');

let metafieldId = null;
let metafieldValue = null;

let metafieldId2 = null;
let metafieldValue2 = null;

let cartTotalPoint;

let buyfrompointdiv = document.querySelector('#buyfrompoint');
if (buyfrompointdiv) {
     cartTotalPoint = buyfrompointdiv.dataset.totalPoint;
}


let html = document.querySelector("html");

if(! html.classList.contains("shopify-design-mode")){
  if (window.location.href.indexOf("login")  === -1 && window.location.href.indexOf("activate")  === -1 && window.location.href.indexOf("reset")  === -1 && window.location.href.indexOf("account-invitation")  === -1 && window.location.href.indexOf("point-setting")  === -1 ) {
     if (customerId == "") {
        window.location.href = `/account/login`;
    }
  }
}




const fetchSettingsData = async () => {
  const response = await fetch(`${shopifyUrl}/admin/api/2024-01/themes/169066987815/assets.json?asset[key]=config/settings_data.json`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': accessToken
    }
  });
  const result = await response.json();
  return result.asset.value; // This is a JSON string
};

const updateSettings = async (newSettingsData) => {
  const response = await fetch(`${shopifyUrl}/admin/api/2024-01/themes/169066987815/assets.json`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': accessToken
    },
    body: JSON.stringify({
      asset: {
        key: 'config/settings_data.json',
        value: newSettingsData
      }
    })
  });

  if (!response.ok) {
    throw new Error(`Error updating settings: ${response.statusText}`);
  }

  const result = await response.json();
  console.log('Settings updated successfully:', result);
};



const updateThemeSetting = async (newAmountLimit) => {
  try {
    // Fetch current settings
    const settingsData = await fetchSettingsData();
    let settings = JSON.parse(settingsData);
    settings.current.amount_limit = newAmountLimit;
    const newSettingsData = JSON.stringify(settings);
    await updateSettings(newSettingsData);
  } catch (error) {
    console.error('Error:', error);
  }
};

// Example usage
// updateThemeSetting(300000);



// const logSettingsAmountLimit = async () => {
//   try {
//     const settingsData = await fetchSettingsData(); // Await the result of the fetch
//     if (settingsData) {
//       let settings = JSON.parse(settingsData);
//       console.log("Setting amount_limit:", settings.current.amount_limit); // Access the amount_limit property
//     }
//   } catch (error) {
//     console.error('Error:', error);
//   }
// };

// // Run the function to log the settings
// logSettingsAmountLimit();






// let amount_limit_formet = amount_limit * 1000;

// if (amount_limit){
//   let amount_limit_formet = amount_limit;
// }

let amount_limit_formet = amount_limit;

console.log("amount_limit_formet", amount_limit_formet);

const metafieldKey = 'points';



// console.log("customerlastOrderid", customerlastOrderid);

// const apiUrl = `${shopifyUrl}/admin/api/${apiVersion}/customers/${customerId}.json`;

const CustomerApiUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=chile`;

const data = {
  customer: {
    id: customerId
  }
};

function get_customr(){
  fetch(CustomerApiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': accessToken,
      'Shopify-Access-Token': accessToken,
    },
   
  })
  .then(response => response.json())
  .then(result => {
    console.log('Success:', result);

       const metafields = result.metafields;
        
        for (let i = 0; i < metafields.length; i++) {
          if (metafields[i].key === 'points') {
              metafieldId = metafields[i].id;
              metafieldValue = metafields[i].value;
            break;
          }
        }

        for (let s = 0; s < metafields.length; s++) {
          if (metafields[s].key === 'total_used_points') {
              metafieldId2 = metafields[s].id;
              metafieldValue2 = parseInt(metafields[s].value, 10);
            break;
          }
        }
    
      if (metafieldId) {
          cartTotalPoint = document.querySelector('#buyfrompoint').dataset.totalPoint
          // let updateV = metafieldValue - cartTotalPoint;
        //   updatePoints(metafieldId, updateV);
        //   let spendVal = metafieldValue2 + parseInt(cartTotalPoint, 10);
        //   updateSpendPoints(metafieldId2, spendVal);

       document.querySelector('#pointuse').value = cartTotalPoint;
       var checkoutButton = document.querySelector('.cart__checkout-button');
       if (checkoutButton) {
            let loader =  document.querySelector('.loading');
            if(loader){
              loader.style.visibility = "hidden";
            }
            checkoutButton.click();
        } 

      }
    
  })
  .catch(error => {
    console.error('Error:', error);
  });

}


// mines points from matefiled
function updatePoints(metafieldId, updatevalue){

   setCookie("pointValue", updatevalue, 1);
   setCookie("pointsId", metafieldId, 1);
  
  const metaUrl = `${shopifyUrl}/admin/api/${apiVersion}/metafields/${metafieldId}.json`;

  const metafieldData = {
    metafield: {
      id: metafieldId,
      value: updatevalue // Replace with the new value for the metafield
    }
  };
  
  fetch(metaUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': accessToken,
        'Shopify-Access-Token': accessToken,
      },
      body: JSON.stringify(metafieldData),
    })
    .then(response => response.json())
    .then(result => {
      // console.log('points updated successfully:', result);
    })
    .catch(error => {
      console.error('Error updating metafield:', error);
    });
}
//updatePoints();
// update total spend
function updateSpendPoints(metafieldId2, spendValue){
  
  const metaUrl = `${shopifyUrl}/admin/api/${apiVersion}/metafields/${metafieldId2}.json`;

  const metafieldData = {
    metafield: {
      id: metafieldId2,
      value: spendValue // Replace with the new value for the metafield
    }
  };
  
  fetch(metaUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': accessToken,
        'Shopify-Access-Token': accessToken,
      },
      body: JSON.stringify(metafieldData),
    })
    .then(response => response.json())
    .then(result => {
      console.log('spend updated:', result);
      cartTotalPoint = document.querySelector('#buyfrompoint').dataset.totalPoint
      
       document.querySelector('#pointuse').value = cartTotalPoint;
       var checkoutButton = document.querySelector('.cart__checkout-button');
       if (checkoutButton) {

           setCookie("totalUsedPoints", spendValue, 1);
           setCookie("total_used_pointsId", metafieldId2, 1);
         
            let loader =  document.querySelector('.loading');
            if(loader){
              loader.style.visibility = "hidden";
            }
            checkoutButton.click();
        } 
      
    })
    .catch(error => {
      console.error('Error updating metafield:', error);
    });
  
}

let cartfooter = document.querySelector('.cart__footer');
if (cartfooter){
cartfooter.addEventListener('click', function(event) {
    if (event.target && event.target.matches('#buyfrompoint')) {

      let loader =  document.querySelector('.loading');
      if(loader){
        loader.style.visibility = "visible";
      }
      
     fetch('https://empleados.diageochile.com/discount/PAGAR%2520CON%2520PUNTOS?redirect=/cart')
      .then(response => {
        // Check if the request was successful
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
         return response.text();
      })
      .then(data => {
        console.log("discount run");
        get_customr();
      })
      .catch(error => {
        // Handle any errors that occurred during the fetch
        console.error('Fetch error:', error);
      });  
 
    }
});

}



if (pagename == "cart"){

let cartdiscount = document.querySelector('.discounts__discount');

$("body").on('click', ".cart-remov", function(){
  if(cartdiscount){
    fetch('/checkout?discount=CLEAR')
      .then(response => {
        console.log('Discount cleared successfully');
         $(this).next().trigger("click");
      })
      .catch(error => {
        // Handle fetch errors
        console.error('Error clearing discount:', error);
      });
  } else {
    $(this).next().trigger("click");
  }
});

function discount_clear(){
  fetch('/checkout?discount=CLEAR')
  .then(response => {
    console.log('Discount cleared successfully');
    window.location.reload();
  })
  .catch(error => {
    // Handle fetch errors
    console.error('Error clearing discount:', error);
  });
}



if(cartdiscount){
  discount_clear();
}

}





// point and amount limit code

function fetchShopifyOrders() {
   // const OrdersapiUrl = `${shopifyUrl}/admin/api/${apiVersion}/customers/${customerId}/orders.json`;
const myHeaders = new Headers();
  myHeaders.append("X-Shopify-Access-Token", accessToken); // Only use this header for authorization
  myHeaders.append("Content-Type", "application/json");

  fetch(CustomerApiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': accessToken,
      'Shopify-Access-Token': accessToken,
    },
   
  })
  .then(response => response.json())
  .then(result => {
       const metafields = result.metafields;
        for (let s = 0; s < metafields.length; s++) {
          if (metafields[s].key === 'total_used_points') {
              metafieldId2 = metafields[s].id;
              metafieldValue2 = parseInt(metafields[s].value, 10);
            break;
          }
        }
    
 // console.log('metafieldValue2', metafieldValue2);

    
    const OrdersapiUrl = `https://empapp.chilediageo.com/api/shopify-orders?customerId=${customerId}&web=chile`;
      fetch(OrdersapiUrl, {
        method: 'GET',
        headers: myHeaders,
      })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(result => {
    // console.log('Fetched orders:', result.orders);
     const orders = result.orders;
    // const totalAmount = calculateTotalAmountLast6Months(orders);

    const totalAmount = customerToatlCashSpent6;
      
      let formetLimit = amount_limit_formet / 100;

    //  let remainAmout = formetLimit - totalAmount;

      let remainAmout = remaingCash;

      
      
    let cartTotalDiv = document.querySelector("#carTotlavalue");
    let cartTotal = 0;
    if (cartTotalDiv){
       cartTotal = cartTotalDiv.getAttribute('data-carttotal') / 100; 
    }
    checkoutButton.style.display = "block";
    // let cashLimit  = formatNumber(amount_limit_formet);

        // console.log("totalAmount", totalAmount);
        //  console.log("cartTotal", cartTotal);
        //   console.log("remainAmout", remainAmout);

     if (totalAmount > formetLimit && metafieldValue2 > semi_point_limit){
          showNotification("Se alcanzó el límite de puntos y el límite de efectivo.");
          let buypointbtn = document.querySelector('#buyfrompoint');
          if(buypointbtn){
            buypointbtn.style.display = "none";
          }
         checkoutButton.style.display = "none";
     } else if (metafieldValue2 > semi_point_limit) {
         showNotification("Límite de puntos alcanzado");
        let buypointbtn = document.querySelector('#buyfrompoint');
        if(buypointbtn){
          buypointbtn.style.display = "none";
        }
     }

    })
    
  });


}
if (pagename == "cart"){
  fetchShopifyOrders();
}



function showNotification(message) {
    const noti = document.createElement('div');
    noti.textContent = message;
    noti.className = 'limit_rechd';
    document.querySelector('.cart__footer .totals').insertAdjacentElement('afterend', noti);
}


function calculateTotalAmountLast365Days(orders) {
    const today = new Date();
    const last365Days = new Date();
    last365Days.setDate(today.getDate() - 365);
    let totalAmount = 0;
    orders.forEach(order => {
        const orderDate = new Date(order.created_at);

        if (orderDate >= last365Days) {
            // Accumulate the total amount, assuming order.total_price is in the currency format
            totalAmount += parseFloat(order.total_price); 
        }
    });
    return totalAmount;
}

function calculateTotalAmountLast6Months_old(orders) {
    const today = new Date();
    const last6Months = new Date();
    last6Months.setMonth(today.getMonth() - 6);
    let totalAmount = 0;
    orders.forEach(order => {
        const orderDate = new Date(order.created_at);

        if (orderDate >= last6Months) {
            // Accumulate the total amount, assuming order.total_price is in the currency format
            totalAmount += parseFloat(order.total_price); 
        }
    });
    return totalAmount;
}


function calculateTotalAmountLast6Months(orders) {
    const today = new Date();
    const currentMonth = today.getMonth(); // 0-based index (0 = January, 11 = December)

    let startDate, endDate;
  
    if (currentMonth < 6) { // January to June
        // Calculate the range from the start of the current month to January 1st
        startDate = new Date(today.getFullYear(), 0, 1); // January 1st of the current year
        endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()); // Last day of the current month
    } else { // July to December
        // Calculate the range from the start of the current month to July 1st
         endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        startDate = new Date(today.getFullYear(), 6, 1); // July 1st of the current year
    }

    let totalAmount = 0;
  
    orders.forEach(order => {
        const orderDate = new Date(order.created_at);

        if (orderDate >= startDate && orderDate < endDate) {
            totalAmount += parseFloat(order.total_price);
        }
    });

    return totalAmount;
}





function calculateTotalPointLast365Days(orders) {
    const today = new Date();
    const last365Days = new Date();
    last365Days.setDate(today.getDate() - 365);
    let totalpoint = 0;
    orders.forEach(order => {
        const orderDate = new Date(order.created_at);

        if (orderDate >= last365Days) {
            if (Array.isArray(order.note_attributes)) {
                const pointUseAttribute = order.note_attributes.find(attr => attr.name === 'Point use');
                
                if (pointUseAttribute) {
                    const pointValue = parseFloat(pointUseAttribute.value);
                    if (!isNaN(pointValue) && isFinite(pointValue)) {
                        totalpoint += pointValue;
                    } else {
                        console.warn('Invalid point value:', pointUseAttribute.value);
                    }
                }
            }
        }
    });
    return totalpoint;
}

function calculateTotalPointLast6Months(orders) {
    const today = new Date();
    const last6Months = new Date();
    last6Months.setMonth(today.getMonth() - 6);
    let totalPoint = 0;
    orders.forEach(order => {
        const orderDate = new Date(order.created_at);

        if (orderDate >= last6Months) {
            if (Array.isArray(order.note_attributes)) {
                const pointUseAttribute = order.note_attributes.find(attr => attr.name === 'Point use');
                
                if (pointUseAttribute) {
                    const pointValue = parseFloat(pointUseAttribute.value);
                    if (!isNaN(pointValue) && isFinite(pointValue)) {
                        totalPoint += pointValue;
                    } else {
                        console.warn('Invalid point value:', pointUseAttribute.value);
                    }
                }
            }
        }
    });
    return totalPoint;
}






function get_lastOrder(){
  fetch(CustomerApiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': accessToken,
      'Shopify-Access-Token': accessToken,
    },
   
  })
  .then(response => response.json())
  .then(result => {
   
       const metafields = result.metafields;

      console.log('metafieldValue:', metafields);
    
        for (let i = 0; i < metafields.length; i++) {
          if (metafields[i].key === 'last_order_id') {
              metafieldId = metafields[i].id;
              metafieldValue = customerlastOrderid;
            break;
          }
        }

      if (metafieldId) {
          console.log('metafieldValue:', metafieldValue);
          updateLastOrderid(metafieldId, metafieldValue);
      }
    
  })
  .catch(error => {
    console.error('Error:', error);
  });

}


function updateLastOrderid(metafieldId, updatevalue){

  const metaUrl = `${shopifyUrl}/admin/api/${apiVersion}/metafields/${metafieldId}.json`;

  const metafieldData = {
    metafield: {
      id: metafieldId,
      value: updatevalue // Replace with the new value for the metafield
    }
  };
  
  fetch(metaUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': accessToken,
        'Shopify-Access-Token': accessToken,
      },
      body: JSON.stringify(metafieldData),
    })
    .then(response => response.json())
    .then(result => {
      console.log('Metafield updated successfully:', result);
      
    })
    .catch(error => {
      console.error('Error updating metafield:', error);
    });
}



// account page display points and cart point limit 

function getMetafield(metafieldId) {
  console.log("here is metafield coming");
 // const metaUrl = `${shopifyUrl}/admin/api/${apiVersion}/customers/${customerId}/metafields.json`;
  
fetch(CustomerApiUrl, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': accessToken
    }
})
.then(response => response.json())
.then(data => {
    const metafields = data.metafields; // Adjust this based on the actual structure of the response
    const pointsMetafield = metafields.find(mf => mf.key === 'points');
         Curntpoints = formatNumber(pointsMetafield.value);
    const total_used_points = metafields.find(mf => mf.key === 'total_used_points');
          totalUsedPoints = formatNumber(total_used_points.value);
    console.log('Metafield data retrieved successfully:', data);
    if (pointsMetafield) {
     // jQuery('.current-points span').text(Curntpoints + ' Puntos');
     // jQuery('.total_used_points span').text(totalUsedPoints + ' Puntos');
    } else {
        console.log('Metafield with key "points" not found.');
    }
})
.catch(error => {
    console.error('Error retrieving metafield:', error);
}); 


}
if(pagename == "account"){
  getMetafield(); 
}



// end get metafield


let remandiv = document.querySelector('.remaining-point span');

if(remandiv){
  if(remaingCash){
    remaingCash = formatCLP(remaingCash)
    remandiv.innerText = remaingCash;
  }
}


function formatNumber(number) {
    return new Intl.NumberFormat('de-DE').format(number);
}

// money formet
function formatCLP(value) {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
}



// Check if this is the first time the page is loaded
if (!sessionStorage.getItem('pageLoaded')) {
    // Run your code here that you want to execute only on the first refresh
    console.log('This is the first time the page is loaded/refreshed.');
    
    get_lastOrder();
    // Set a flag in sessionStorage to indicate the page has been loaded
    sessionStorage.setItem('pageLoaded', 'true');
} else {
    console.log('The page has been loaded/refreshed before.');
}




// password page code
  let form = document.querySelector("[name=passwordsform]");
  let formPlace = document.querySelector(".reset-form-place");

  let formNotifiction;
if(form){
  
  form.addEventListener("submit", function(event) {
    event.preventDefault(); // Prevent default form submission

    let password = document.getElementById("password").value;
    
    if (password.trim() == passwordMain) {

        document.querySelector('.loading').style.visibility = "visible";
      
        setTimeout(function(){
          document.querySelector('.loading').style.visibility = "hidden";
          renderShopifySection();           
        }, 1000);
      
    } else {
      alert("Incorrect password. Please try again."); 
      password.value = '';
    }
    
  });
}

function renderShopifySection(){
  fetch(`${routes.cart_url}?section_id=rest-possword-form`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceQty = html.querySelector('.shopify-section');
        formPlace.innerHTML = sourceQty.innerHTML;
        restFromjs();
        document.querySelector('.passwordformdiv').style.display = "none";
    })
    .catch((e) => {
      console.error(e);
    });
}

function restFromjs(){
  let formPoint = document.querySelector("[name=reset-point]");
  formPoint.addEventListener("submit", function(event) {
    event.preventDefault();
    let pointvalue = document.getElementById("pointvalue").value;

    if (!isValidNumber(pointvalue)) {
        alert("Invalid input: Please enter number only.");
      return;
    }
    if (confirm('Are you sure you want to reset all user points?')) {
        updateAllcustomermetafield(pointvalue);
    } 
    
    console.log('Point' + pointvalue);
  });



// Bouns form
let bonusForm = document.querySelector("[name=add-bonus-point]");
bonusForm.addEventListener("submit", function(event) {
  event.preventDefault();
  let BonusPointvalue = document.getElementById("addbonus").value;

  if (!isValidNumber(BonusPointvalue)) {
      alert("Invalid input: Please enter number only.");
    return;
  }
  if (confirm('Are you sure you want to give bonus points to all user?')) {
    //  updateAllcustomermetafield(pointvalue);

    updateBonus(BonusPointvalue);
    
  } 
  
  console.log('Point' + pointvalue);
});


  
// update point value form  
let formPointVal = document.querySelector("[name=poitn-value]");
  formPointVal.addEventListener("submit", function(event) {
    event.preventDefault();
    
     let dollarValue = document.getElementById("dollarval").value;
     let pointValue = document.getElementById("pointval").value;

     if (!isValidNumber(dollarValue) || !isValidNumber(pointValue)) {
          alert("Invalid input: Please enter valid numbers.");
          return;
      }
       
      const conversionRate = dollarValue / pointValue;

      if (confirm('Are you sure you want to reset all Products point value?')) {
        formNotifiction = document.querySelector('.form-not');
        if(formNotifiction){
          formNotifiction.style.color = "#000";
          formNotifiction.innerText = "Please wait"
        }
         updateAllProductMetafields(conversionRate)
      }
    
  });


let FormcashLimit = document.querySelector("[name=cash-limit]");
  FormcashLimit.addEventListener("submit", function(event) {
    event.preventDefault();
    
     let cashlimit = document.getElementById("cashlimit").value;
     
     if (!isValidNumber(cashlimit)) {
          alert("Invalid input: Please enter valid numbers.");
          return;
      }
       
      if (confirm('Are you sure you want to reset cash limit?')) {
        formNotifiction = document.querySelector('.form-not');
        if(formNotifiction){
            formNotifiction.style.color = "#000";
            formNotifiction.innerText = "Please wait"
        }
         cashLimitForm(cashlimit)
      }
    
  });


let premiumLimt = document.querySelector("[name=premium-limt]");
  premiumLimt.addEventListener("submit", function(event) {
    event.preventDefault();
    
     let premiumLimt = document.getElementById("premiumLimt").value;
       
      if (confirm('¿Está seguro de que desea restablecer el límite de compra de reservas para todos los usuarios?')) {
        formNotifiction = document.querySelector('.form-not');
        if(formNotifiction){
            formNotifiction.style.color = "#000";
            formNotifiction.innerText = "Please wait"
        }
         premiumLimitForm(premiumLimt)
      }
    
  });


let normalPlimt = document.querySelector("[name=normalP-limt]");
  normalPlimt.addEventListener("submit", function(event) {
    event.preventDefault();
    
     let normalPLimtVal = document.getElementById("normalPLimt").value;
       
      if (confirm('¿Está seguro de que desea restablecer el límite de compra de unidades para todos los usuarios?')) {
        formNotifiction = document.querySelector('.form-not');
        if(formNotifiction){
            formNotifiction.style.color = "#000";
            formNotifiction.innerText = "Please wait"
        }
        normalProductLimt(normalPLimtVal)
      }
    
  });


  
} // restFromjs close



function isValidNumber(value) {
  return /^\d+$/.test(value.trim());
}


const getAllCustomer = `https://empapp.chilediageo.com/api/shopify-customers?web=chile`;


function updateBonus(BonusPointvalue){
  fetch(getAllCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(result => {
        const customerIds = result.customers.map(customer => customer.id);

       const totalCustomers = customerIds.length;
       let completedRequests = 0;

      
         console.log("customerIds", customerIds);

        //  customerIds.forEach((customerId, index) => {
        // // customerIds.forEach(customerId => {

        //   setTimeout(() => {
           
        //    const metaUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=peru`;

        //     fetch(metaUrl, {
        //       method: 'GET',
        //       headers: {
        //         'Content-Type': 'application/json'
        //       }
        //     })
        //     .then(response => response.json())
        //     .then(result => {

        //      console.log("result", result);
              
        //       const metafields = result.metafields;
        //       const pointsMetafield = metafields?.find(mf => mf.key === 'points');

        //        let oldPoint = Math.floor(pointsMetafield?.value);
        //        let updatePoint  = oldPoint + Math.floor(BonusPointvalue);
             
        //       const metafieldData = {
        //          metafield: {
        //           namespace: 'custom',
        //           key: 'points',
        //           value: updatePoint
        //         }
        //       };
        
        //       fetch(metaUrl, {
        //         method: 'POST',
        //         headers: {
        //           'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify(metafieldData),
        //       })
        //       .then(response => response.json())
        //       .then(data => {
        //           formNotifiction = document.querySelector('.form-not');
        //             if(formNotifiction){
        //               formNotifiction.innerText = "Bono actualizado con éxito."
        //           }
        //       })
              
              
        //     })


        //   }, index * 800);
           
        //  });


        const updatePromises = customerIds.map((customerId, index) => {
              return new Promise((resolve) => {
                setTimeout(() => {
                  const metaUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=chile`;
        
                  // Fetch current metafields
                  fetch(metaUrl, {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  })
                  .then(response => response.json())
                  .then(result => {
                    const metafields = result.metafields;
                    const pointsMetafield = metafields?.find(mf => mf.key === 'points');
                    let oldPoint = Math.floor(pointsMetafield?.value || 0); // Default to 0 if not found
                    let updatePoint = oldPoint + Math.floor(BonusPointvalue);
        
                    const metafieldData = {
                      metafield: {
                        namespace: 'custom',
                        key: 'points',
                        value: updatePoint
                      }
                    };
        
                    // Update points metafield
                    return fetch(metaUrl, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(metafieldData)
                    });
                  })
                  .then(() => {
                    completedRequests++;
                    updateProgressBar(completedRequests, totalCustomers);
                    resolve(); // Resolve the promise on completion
                  })
                  .catch(error => {
                    console.error(`Error updating customer ${customerId}:`, error);
                    completedRequests++;
                    updateProgressBar(completedRequests, totalCustomers);
                    resolve(); // Resolve even if there's an error
                  });
                }, index * 800); // Delay between requests
              });
            });
        
            // Show success message after all updates are complete
            Promise.all(updatePromises).then(() => {
              const formNotifiction = document.querySelector('.form-not');
              if (formNotifiction) {
                formNotifiction.innerText = "Bono actualizado con éxito.";
              }
            });
      
    })
    .catch(error => {
      console.error('Error:', error);
    });


  function updateProgressBar(completed, total) {
      const progress = (completed / total) * 100;
      const progressBarCont = document.getElementById('progress-container');
      const progressBar = document.getElementById('progress-bar');
      progressBarCont.style.display = 'block';
      progressBar.style.width = `${progress}%`;
      progressBar.textContent = `${Math.round(progress)}%`;
  }
  
  
}




// update All customer points metafield 

function updateAllcustomermetafield(pointvalue) {
  function get_Allcustomr() {
    fetch(getAllCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(result => {
        const customerIds = result.customers.map(customer => customer.id);

        const totalCustomers = customerIds.length;
        let completedRequests = 0;

        //console.log('Customer IDs:', customerIds);
        // customerIds.forEach(customerId => {
        //   updateCustomerMetafields(customerId, pointvalue, 0);
        // });

        customerIds.forEach((customerId, index) => {
          setTimeout(() => {
             // console.log('Customer IDs:', customerId);
             // updateCustomerMetafields(customerId, pointvalue, 0);

          updateCustomerMetafields(customerId, pointvalue, 0)
            .then(() => {
              // Increment completed requests and update progress bar
              completedRequests++;
              updateProgressBar(completedRequests, totalCustomers);

              if (completedRequests === totalCustomers) {
                formNotifiction = document.querySelector('.form-not');
                if(formNotifiction){
                  formNotifiction.innerText = "Puntos actualizados con éxito"
                }
                
              }
              
            })
            .catch(error => {
              console.error(`Error updating customer ${customerId}:`, error);
              // Still increment for failed requests to move progress forward
              completedRequests++;
              updateProgressBar(completedRequests, totalCustomers);
            });

            
          }, index * 800); 
        });
        
      
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  function getCustomerMetafields(customerId, key, value) {
    
      const metafieldData = {
         metafield: {
          namespace: 'custom',
          key: key,
          value: value
        }
      };

      const metaUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=chile`;
      fetch(metaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(metafieldData),
      })
      .then(response => response.json())
      .then(data => {
      //  console.log(`Success getCustomerMetafields for customer ${customerId}:`, data);
        
      })
      .catch(error => {
        console.error(`Error fetching metafields for customer ${customerId}:`, error);
      });
    }



function updateCustomerMetafields(customerId, pointValue, totalUsedPoints) {
  // Update the 'points' metafield
  // getCustomerMetafields(customerId, 'points', pointValue);
  // // Update the 'total_used_points' metafield
  // getCustomerMetafields(customerId, 'total_used_points', totalUsedPoints);

  return Promise.all([
      getCustomerMetafields(customerId, 'points', pointValue),
      getCustomerMetafields(customerId, 'total_used_points', totalUsedPoints)
    ]);

}


function updateProgressBar(completed, total) {
    const progress = (completed / total) * 100;
    const progressBarCont = document.getElementById('progress-container');
    const progressBar = document.getElementById('progress-bar');
    progressBarCont.style.display = 'block';
    progressBar.style.width = `${progress}%`;
    progressBar.textContent = `${Math.round(progress)}%`;
}
  
  get_Allcustomr();
  
}





function cashLimitForm(cashlimit) {

  function get_AllcustomrForCash() {
    fetch(getAllCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(result => {
        const customerIds = result.customers.map(customer => customer.id);

        const totalCustomers = customerIds.length;
        let completedRequests = 0;
      
        //console.log('Customer IDs:', customerIds);
        // customerIds.forEach(customerId => {
        //     getCustomerMetafields(customerId, 'cash_spent_in_last_6_month', 0)
        // });

        customerIds.forEach((customerId, index) => {
          setTimeout(() => {
            getCustomerMetafields(customerId, 'cash_spent_in_last_6_month', 0);

            completedRequests++;
            updateProgressBar(completedRequests, totalCustomers);
  
            if (completedRequests === totalCustomers) {

                formNotifiction = document.querySelector('.form-not');
                  if(formNotifiction){
                    formNotifiction.style.color = "#1fb555";
                    formNotifiction.innerText = "Límite de efectivo actualizado con éxito"
                }
              
            }

            
          }, index * 300); 
        });

      
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  function getCustomerMetafields(customerId, key, value) {
    
      const metafieldData = {
         metafield: {
          namespace: 'custom',
          key: key,
          value: value
        }
      };
    
      const metaUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=chile`;
      fetch(metaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(metafieldData),
      })
      .then(response => response.json())
      .then(data => {

        
      })
      .catch(error => {
        console.error(`Error fetching metafields for customer ${customerId}:`, error);
      });
    }
  
  get_AllcustomrForCash();

}



 // premium product limit reset
function premiumLimitForm(limit) {

  function get_AllcustomrForPremium() {
    fetch(getAllCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(result => {
        const customerIds = result.customers.map(customer => customer.id);

        const totalCustomers = customerIds.length;
        let completedRequests = 0;

        customerIds.forEach((customerId, index) => {
          setTimeout(() => {
            getCustomerMetafields(customerId, 'premium_purchase', 0);

            completedRequests++;
            updateProgressBar(completedRequests, totalCustomers);
  
            if (completedRequests === totalCustomers) {

                formNotifiction = document.querySelector('.form-not');
                  if(formNotifiction){
                    formNotifiction.style.color = "#1fb555";
                    formNotifiction.innerText = "El límite de reserva de productos se actualizó correctamente"
                }
              
            }

            
          }, index * 300); 
        });

      
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  function getCustomerMetafields(customerId, key, value) {
    
      const metafieldData = {
         metafield: {
          namespace: 'custom',
          key: key,
          value: value
        }
      };
    
      const metaUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=chile`;
      fetch(metaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(metafieldData),
      })
      .then(response => response.json())
      .then(data => {

        
      })
      .catch(error => {
        console.error(`Error fetching metafields for customer ${customerId}:`, error);
      });
    }
  
  get_AllcustomrForPremium();

}


// normal product unit reset

function normalProductLimt(limit) {

  function get_AllcustomrForNormal() {
    fetch(getAllCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(result => {
        const customerIds = result.customers.map(customer => customer.id);

        const totalCustomers = customerIds.length;
        let completedRequests = 0;

        customerIds.forEach((customerId, index) => {
          setTimeout(() => {
            getCustomerMetafields(customerId, 'normal_purchase', 0);

            completedRequests++;
            updateProgressBar(completedRequests, totalCustomers);
  
            if (completedRequests === totalCustomers) {
                formNotifiction = document.querySelector('.form-not');
                  if(formNotifiction){
                    formNotifiction.style.color = "#1fb555";
                    formNotifiction.innerText = "El límite de producto regular se ha actualizado correctamente"
                }
            }
            
          }, index * 300); 
        });

      
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }

  function getCustomerMetafields(customerId, key, value) {
      const metafieldData = {
         metafield: {
          namespace: 'custom',
          key: key,
          value: value
        }
      };
      const metaUrl = `https://empapp.chilediageo.com/api/shopify-metafields?customerId=${customerId}&web=chile`;
      fetch(metaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(metafieldData),
      })
      .then(response => response.json())
      .then(data => {

        
      })
      .catch(error => {
        console.error(`Error fetching metafields for customer ${customerId}:`, error);
      });
    }
  
  get_AllcustomrForNormal();

}




function updateProgressBar(current, total) {
    const progress = (current / total) * 100;
    const progressBarCont = document.getElementById('progress-container');
    const progressBar = document.getElementById('progress-bar');
    progressBarCont.style.display = 'block';
    progressBar.style.width = `${progress}%`;
    progressBar.textContent = `${Math.round(progress)}%`;
}


// Function to update all product metafields with the conversion rate
function updateAllProductMetafields(conversionRate) {
    const getAllProducts = `https://empapp.chilediageo.com/api/shopify-get-allproducts?web=chile`;

    fetch(getAllProducts, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json()) // Parse the JSON response
    .then(result => {
        const products = result.products; // Extract products from the response
        const totalProducts = products.length;
        let completedRequests = 0;

        const updatePromises = products.map((product, index) => {

            const productPrice = parseFloat(product.variants[0].price); // Get product price from the first variant
            const productConversionRate = productPrice / conversionRate;

            return new Promise((resolve) => {
                setTimeout(() => {
                   
                    updateProductMetafield(product.id, productConversionRate.toFixed(2)).then(() => {
                        completedRequests++;
                        updateProgressBar(completedRequests, totalProducts);
                        resolve();
                    });
                }, index * 280); // Delay each request
            });

        });
        return Promise.all(updatePromises);
    })
    .then(() => {
        console.log('All product metafields updated successfully.');

        formNotifiction = document.querySelector('.form-not');
        if(formNotifiction){
           formNotifiction.style.color = "#1fb555";
          formNotifiction.innerText = "All Products Successfully updated."
        }
      
    })
    .catch(error => {
        console.error('Error fetching or updating products:', error);

       formNotifiction = document.querySelector('.form-not');
        if(formNotifiction){
          formNotifiction.style.color = "#e70b0b";
          formNotifiction.innerText = "Something went wrong. Try again later."
        }
      
    });
}

// Function to update the metafield of a single product
function updateProductMetafield(productId, productConversionRate) {
    const metafieldData = {
        metafield: {
            namespace: 'custom',
            key: 'product_points', 
            value: productConversionRate.toString(), 
        }
    };
  
    // Send a POST request to update the product's metafield
    return fetch(`https://empapp.chilediageo.com/api/shopify-product-metafield?productId=${productId}&web=chile`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(metafieldData), 
    })
    .then(response => response.json())
    .then(result => {
        console.log(`Updated product ${productId} with conversion rate: ${productConversionRate}`);
    })
    .catch(error => {
        console.error(`Error updating product ${productId}:`, error);
    });
}



function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + (value || "") + ";" + expires + ";path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


// update points on Fixd date 
function checkAndRunFunction() {
    const now = new Date();
    const cookieName = "pointUpdated";
    const cookieValue = getCookie(cookieName);

    if (cookieValue) {
        console.log("points already update today.");
        return;
    }
    if ((now.getMonth() === 0 && now.getDate() === 1) || (now.getMonth() === 6 && now.getDate() === 1)) {
        const pointvalue = 60;
        updateAllcustomermetafield(pointvalue);
        console.log("Point update");
        // Set the cookie to prevent running again today
        setCookie(cookieName, "true", 1);
    }
  
}
checkAndRunFunction();



  